import { SkeletonTheme } from 'react-loading-skeleton'
import { useTheme } from 'styled-components'
import * as S from './ImageSkeleton.styles'

interface ImageSkeletonProps {
  aspectRatio?: string
}

export const ImageSkeleton = ({
  aspectRatio = '3 / 4',
}: ImageSkeletonProps): JSX.Element => {
  const theme = useTheme()

  return (
    <SkeletonTheme
      baseColor={theme.colors.secondary}
      highlightColor={theme.colors.disabled}
    >
      <S.ImageSkeletonContainer aspectRatio={aspectRatio}>
        <S.StyledSkeleton aspectRatio={aspectRatio} />
      </S.ImageSkeletonContainer>
    </SkeletonTheme>
  )
}
